'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

exports.default = gridClassName;

var _filterDOMProps = require('uniforms/filterDOMProps');

var _filterDOMProps2 = _interopRequireDefault(_filterDOMProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_filterDOMProps2.default.register('grid');

function gridClassNamePart(size, value, side) {
    return side === 'label' ? 'col-' + size + '-' + value : 'col-' + size + '-' + (12 - value);
}

function gridClassName(grid, side) {
    // Example: 6
    if (typeof grid === 'number') {
        return gridClassNamePart('sm', grid, side);
    }

    // Example: '6'
    if (typeof grid === 'string' && !isNaN(parseInt(grid))) {
        return gridClassNamePart('sm', parseInt(grid), side);
    }

    // Example: 'col-md-6'
    if (typeof grid === 'string') {
        return grid;
    }

    // Example: {xs: 6, sm: 4, md: 3}
    if ((typeof grid === 'undefined' ? 'undefined' : (0, _typeof3.default)(grid)) === 'object') {
        return Object.keys(grid).map(function (size) {
            return gridClassNamePart(size, grid[size], side);
        }).join(' ');
    }

    return '';
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/uniforms-bootstrap3/gridClassName.js
 ** module id = ./node_modules/uniforms-bootstrap3/gridClassName.js
 ** module chunks = 0
 **/